// extracted by mini-css-extract-plugin
export default {"formItem":"PackageCancellationRequestModal_formItem__Mxdtg","formFooter":"PackageCancellationRequestModal_formFooter__fTPUR"};